module.exports = __webpack_public_path__ + "static/media/_space_yellow.e9f7f1bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/alphabet/_space_yellow.jpg
// module id = 48
// module chunks = 0